<template>
  <nav class="bg-gray-700 shadow-md">
    <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
      <div class="relative flex items-center justify-between h-16">
        <div
          class="flex-1 flex items-center justify-around sm:items-stretch sm:justify-between"
        >
          <div class="flex-shrink-0 flex items-center text-white">
            Admin-Center
          </div>
          <div class="sm:block sm:ml-6">
            <div class="flex space-x-4">
              <span
                @click="dispatchLogout"
                class="px-3 py-3 rounded-md text-sm font-medium text-white bg-gray-900 cursor-pointer"
              >
                Logout
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden sm:hidden">
      <div class="px-2 pt-2 pb-3 space-y-1">
        <span
          @click="dispatchLogout"
          class="px-3 py-3 rounded-md text-sm font-medium text-white bg-gray-900 cursor-pointer"
          >Logout</span
        >
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  methods: {
    dispatchLogout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({
          name: 'Auth'
        })
      })
    }
  }
}
</script>
